module.exports = __webpack_public_path__ + "static/img/class_14.e3180b01.jpg";